import { call, takeLatest, put, select } from 'redux-saga/effects'
import { actionTypes } from '../actions/foodActions'
import { sendRequest } from '../services/apiService'
import { setLoading, setLoadingInit } from '../actions/appActions'
import { getRestaurantInfo } from './selectors'
import apiConfig from '../constants/apiConfig'
import { checkTimeCanAddFood } from '../utils'
import { ensureArray } from '../utils/helper'
import { getRestaurantId } from '../selectors'
import { FOOD_KIND } from '../constants'

const parseFoodObj = food => {
    const {
        price,
        beilages,
        settings,
        happyHoursSetting,
        ...rest
    } = food

    return {
        ...rest,
        price: JSON.parse(price || '{}'),
        beilageItems: beilages || [],
        settings: JSON.parse(settings || '{}'),
        happyHoursSetting: JSON.parse(happyHoursSetting || '{}'),
    }
}

function* _getListFood({ payload: { params, onDone } }) {
    try {
        yield put(setLoadingInit(true))
        const response = yield call(sendRequest, apiConfig.food.listFood, {});

        const { responseData, success } = response
        if (success && responseData.data) {
            const { data } = responseData
            yield put({
                type: actionTypes.SET_LIST_FOOD,
                payload: ensureArray(data)
                    // TODO: Tạm thời bỏ hết món gộp món chọn
                    .filter(f => (
                        [FOOD_KIND.NORMAL, FOOD_KIND.FOOD_SUBS].includes(f.kind) &&
                        checkTimeCanAddFood(f)
                    ))
                    .reduce((rs, current) => {
                        const currentId = current.group.id
                        const food = parseFoodObj(current)
                        if (food.subs) {
                            food.subs = food.subs.map(f => parseFoodObj(f))
                        }

                        !rs[currentId] && (rs[currentId] = [])
                        rs[currentId].push(food)

                        return rs
                    }, {}),
            })
        }

        onDone && onDone(response)
    } catch (error) {
    } finally {
        yield put(setLoadingInit(false))
    }
}

function* _searchFood({ payload: { params, onDone } }) {
    const { accountId, hash } = yield select(getRestaurantInfo);
    const restaurantId = yield select(getRestaurantId);
    // yield put(setLoading(true))
    const response = yield call(sendRequest, apiConfig.food.search, {
        restaurantId,
        accountId,
        hash,
        ...params,
    })
    // yield put(setLoading(false))
    onDone(response)
}

function* _getOne({ payload: { params, onDone } }) {
    const {
        accountId,
        hash,
        settings: { happy_hours_settings },
    } = yield select(getRestaurantInfo);
    const restaurantId = yield select(getRestaurantId);
    yield put(setLoading(true))
    const { success, responseData } = yield call(
        sendRequest,
        apiConfig.food.getOne,
        {
            restaurantId,
            accountId,
            hash,
            ...params,
        }
    )
    yield put(setLoading(false))
    if (success && responseData && responseData.data && onDone) {
        responseData.data.beilageItems = JSON.parse(
            responseData.data.beilageItems || '[]'
        )
        responseData.data.happyHoursSetting = JSON.parse(
            responseData.data.happyHoursSetting || '[]'
        )
        onDone({ success, responseData })
    }
}

const sagas = [
    takeLatest(actionTypes.GET_LIST_FOOD, _getListFood),
    takeLatest(actionTypes.SEARCH_FOOD, _searchFood),
    takeLatest(actionTypes.GET_ONE, _getOne),
]

export default sagas
